export default "__VITE_ASSET__CLi74$RM__";